import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ProblemSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section id="producto" className="py-20 md:py-32 bg-[#050505] relative overflow-hidden" data-id="element-262">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-263" />

      <div className="container mx-auto px-4 max-w-6xl" data-id="element-264">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight" data-id="element-266">
            El sistema actual está roto
          </h2>
          <p className="text-gray-400 text-xl" data-id="element-267">¿Te suena familiar?</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-268">
          {[{
          title: 'Prompting = Lento',
          desc: 'Pasás 3 horas escribiendo prompts para sacar 5 creativos mediocres. Mientras tanto, tu competencia ya lanzó 50.'
        }, {
          title: 'Tools Genéricas = Output Genérico',
          desc: 'Canva, Midjourney, ChatGPT... todo lindo, pero nada vende. Porque no están diseñados para ads que conviertan.'
        }, {
          title: 'Manual = Imposible',
          desc: 'Tu diseñador tarda una semana en entregar 10 creativos. Para cuando los tenés, el mercado ya cambió.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: i * 0.2,
          duration: 0.5
        }} className="glass-card p-8 rounded-2xl relative group hover:bg-white/[0.05] transition-colors overflow-visible" data-id="element-269">
              <div className="absolute -top-4 left-4 text-6xl font-bold text-white/[0.06] font-sora group-hover:text-white/[0.1] transition-colors select-none pointer-events-none" data-id="element-270">
                0{i + 1}
              </div>
              <XCircleIcon className="w-8 h-8 text-red-500 mb-6" data-id="element-271" />
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-272">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-273">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isVisible ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="glass-card border-l-4 border-l-purple-500 p-8 md:p-10 rounded-2xl max-w-3xl mx-auto text-center bg-gradient-to-r from-purple-900/10 to-transparent" data-id="element-274">
          <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-275">
            "Mientras vos perfeccionás un diseño, tu competencia ya testeó 50."
          </p>
          <a href="#pricing" className="text-purple-400 hover:text-purple-300 font-bold text-lg flex items-center justify-center gap-2 group" data-id="element-276">
            Hay una forma mejor
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-277">
              →
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}